import { render, staticRenderFns } from "./PersistCargaAryztaView.vue?vue&type=template&id=90cf634a&"
import script from "./PersistCargaAryztaView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaAryztaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports